export const ApplicationUserList = [
  {
    Active: true,
    ApplicationRole: 'ProductionManager',
    UserName: '管理者',
    Email: 'ProductionManager@aaa.com',
  },
  {
    Active: true,
    ApplicationRole: 'Production',
    UserName: '一般',
    Email: 'Production@aaa.com',
  },
  {
    Active: true,
    ApplicationRole: 'Legal',
    UserName: '法務・コンプライアンス',
    Email: 'Legal@aaa.com',
  },
  {
    Active: true,
    ApplicationRole: 'ProductionManager',
    UserName: 'ペガサス・J・クロフォード',
    Email: 'Pegasasu@aaa.com',
  },
  {
    Active: true,
    ApplicationRole: 'ProductionManager',
    UserName: '海馬瀬戸',
    Email: 'Kaiba@aaa.com',
  },
  {
    Active: true,
    ApplicationRole: 'Production',
    UserName: '武藤遊戯',
    Email: 'Yuugi@aaa.com',
  },
  {
    Active: true,
    ApplicationRole: 'Production',
    UserName: '城之内勝也',
    Email: 'Jounouchi@aaa.com',
  },
  {
    Active: true,
    ApplicationRole: 'Legal',
    UserName: 'あんず',
    Email: 'Anzu@aaa.com',
  },
];
